import { FeatureToggleClientService } from 'feature-toggle-client';
export const PluginAction = 'plugin';
export const MarketplacePlugin = 'marketplace-plugin';
export const ConfigurationsApplicationsDomainUsageGet = 'use-configurations-domain-on-misc-operations-get';
export const ConfigurationsApplicationsDomainUsageSet = 'use-configurations-domain-on-misc-operations-set';
export const EnablePluginPermissionScopes = 'enable-plugin-permission-scopes';
export class ExternalPluginFeatures {
    static isPluginEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(PluginAction);
    }
    static isMarketplacePluginEnabled() {
        return FeatureToggleClientService.getInstance().isUserFeatureEnabled(MarketplacePlugin);
    }
    static isUseConfigurationsDomainOnMiscOperationsGetEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ConfigurationsApplicationsDomainUsageGet, false);
    }
    static isUseConfigurationsDomainOnMiscOperationsSetEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ConfigurationsApplicationsDomainUsageSet, false);
    }
    static isPluginPermissionsEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(EnablePluginPermissionScopes, false);
    }
}
